export const painPoints = [
  {
    icon: 'layers',
    title: 'You observe several behaviors but don’t know where to begin.',
    text: 'A child responds differently across situations, and you’re trying to determine which observations deserve closer attention.',
  },
  {
    icon: 'clock',
    title: 'You spend too much time reviewing theory.',
    text: 'You know the terminology, but you still find yourself searching through books, notes, and course materials to organize a real case.',
  },
  {
    icon: 'help',
    title: 'You’re unsure how to interpret a behavior.',
    text: 'You recognize a possible sensory modulation question, but you don’t want to assume that one behavior automatically explains what’s happening.',
  },
  {
    icon: 'clipboard',
    title: 'You have information from different sources.',
    text: 'Session observations, family reports, routines, and contextual details are scattered across different notes.',
  },
  {
    icon: 'search',
    title: 'You suspect something is missing.',
    text: 'You want to identify the additional information that could help you understand the situation more clearly.',
  },
  {
    icon: 'target',
    title: 'You want to connect your analysis with functional participation.',
    text: 'You need a more organized way to move from observations and questions toward meaningful functional goals.',
  },
];

export const pathwaySteps = [
  'Functional concern',
  'Context',
  'Observations',
  'Possible patterns',
  'Missing information',
  'Working hypothesis',
];
